import { Card, CardBody, Heading } from '@apollo/orbit';
import React from 'react';

import Restricted from 'src/assets/restricted.svg';

import { useGraphVisibility } from '../hooks/useGraphVisibility';

export const NonPublicGraphArea = ({
  children,
}: {
  children: React.ReactElement;
}) => {
  const graphVisibilityType = useGraphVisibility();

  if (graphVisibilityType === 'public') {
    return (
      <Card className="m-8 pb-24 pt-12">
        <CardBody className="items-center text-center">
          <Restricted className="mb-6 text-icon-primary" />
          <Heading as="h1" size="3xl">
            Not available
          </Heading>
          <div className="w-120 text-lg leading-relaxed">
            This feature is not available on Public Variants
          </div>
        </CardBody>
      </Card>
    );
  }
  return children;
};
